import DEV_ENV from "../env/dev-env.json"
import INT_ENV from "../env/int-env.json"
import QA_ENV from "../env/qa-env.json"
import QA_BETA_ENV from "../env/qa-beta-env.json"
import PROD_ENV from "../env/prod-env.json"
import LOCAL_ENV from "../env/local-env.json"

const REST_PROTOCOL = window.location.protocol
export const ORIGIN = window.location.origin
const HOST = window.location.host
const API_VERSION = "v1.0"
export const PROD = "PROD"
export const QA = "QA"
export const QA_BETA = "QA_BETA"
export const INT = "INT"
export const DEV = "DEV"
export const LOCAL = "LOCAL"
export const OXE_SYNC_INTERVAL = 1800000

const getCurrentEnv = () => {
    if (HOST === "umc.opentouch.com")
        return { env: PROD, var: PROD_ENV }
    else if (HOST === "qa.umc.opentouch.com")
        return { env: QA, var: QA_ENV }
    else if (HOST === "beta.qa.umc.opentouch.com")
        return { env: QA_BETA, var: QA_BETA_ENV }
    else if (HOST === "int.umc.opentouch.com")
        return { env: INT, var: INT_ENV }
    else if (HOST === "umc.local")
        return { env: DEV, var: DEV_ENV }
    else return { env: LOCAL, var: LOCAL_ENV }
}

const currEnv = getCurrentEnv()
const ENV_VAR = currEnv.var
export const ENV = currEnv.env

/* API URLs */

export const IAM_URL = !window.location.port ? ORIGIN + `/api/${API_VERSION}/umc/iam` : `${REST_PROTOCOL}//${ENV_VAR[`REACT_APP_IAM_URL`]}`
export const UUM_URL = !window.location.port ? ORIGIN + `/api/${API_VERSION}/umc/easyuum` : `${REST_PROTOCOL}//${ENV_VAR[`REACT_APP_UUM_URL`]}`
export const IAM_SSO_URL = !window.location.port ? ORIGIN + `/api/${API_VERSION}/umc/iam-sso` : `${REST_PROTOCOL}//${ENV_VAR[`REACT_APP_IAM_SSO_URL`]}`
export const SIP_URL = !window.location.port ? ORIGIN + `/api/${API_VERSION}/umc/easysiptrunk` : `${REST_PROTOCOL}//${ENV_VAR[`REACT_APP_SIP_URL`]}`
export const CONFIG_DATA_URL = !window.location.port ? ORIGIN + `/api/${API_VERSION}/umc/userappconfigdata` : `${REST_PROTOCOL}//${ENV_VAR[`REACT_APP_CONFIG_DATA_URL`]}`
export const EC_URL = !window.location.port ? ORIGIN + `/api/${API_VERSION}/umc/expertconfig` : `${REST_PROTOCOL}//${ENV_VAR[`REACT_APP_EC_URL`]}`
export const AI_DOC_URL = !window.location.port ? ORIGIN + `/api/${API_VERSION}/umc/aidoc` : `${REST_PROTOCOL}//${ENV_VAR[`REACT_APP_AI_DOC`]}`
export const OXE_OP_URL = !window.location.port ? ORIGIN + `/api/${API_VERSION}/umc/operation` : `${REST_PROTOCOL}//${ENV_VAR[`REACT_APP_OXE_OP_URL`]}`
export const OXE_SYNC_URL = !window.location.port ? ORIGIN + `/api/${API_VERSION}/umc/oxesync` : `${REST_PROTOCOL}//${ENV_VAR[`REACT_APP_OXE_SYNC_URL`]}`
export const DIRECTORY_SYNCHRO_URL = !window.location.port ? ORIGIN + `/api/${API_VERSION}/umc/directory-synchro` : `${REST_PROTOCOL}//${ENV_VAR[`REACT_APP_DIRECTORY_SYNC_URL`]}`

export const EC_APP_URL = `${REST_PROTOCOL}//${ENV_VAR[`REACT_APP_EC_APP_URL`]}`
export const FLEET_URL = `${ENV_VAR[`REACT_APP_FLEET_URL`]}`
export const MYPORTAL_URL = `${ENV_VAR[`REACT_APP_MYPORTAL_URL`]}`
export const RAINBOW_URL = "https://web.openrainbow.com/"
export const EC_ERROR_URL = `/api/mgt/1.0/error/`

/* SAML Constants */
export const SSO_ENTITY_ID = ENV_VAR[`REACT_APP_SSO_ENTITY_ID`]
export const SSO_LOGIN_URL = ENV_VAR[`REACT_APP_SSO_LOGIN_URL`]
export const SSO_LOGOUT_URL = ENV_VAR[`REACT_APP_SSO_LOGOUT_URL`]

//Azure
// export const LOCAL_ENTITY = "test_id_12345678"
// export const LOCAL_LOGIN_URL = "https://login.microsoftonline.com/93806f13-c9c3-4623-831a-7f7c223429c2/saml2"
// export const LOCAL_LOGOUT_URL = "https://login.microsoftonline.com/93806f13-c9c3-4623-831a-7f7c223429c2/saml2"


/* Links page URLs */
// export const ALE_PUB_PORTAL = "https://al-enterprise.com/"
// export const BUSINESS_PARTNER_E_BUY = "https://ebuy.businesspartner.al-enterprise.com/"
// export const DECT_MGT = "https://ebuy.businesspartner.al-enterprise.com/codepari/menu_paricode.aspx"
// export const RAINBOW_SUP = "https://support.openrainbow.com/"


/* GTM constants */
export const GTM_ID = ENV_VAR[`REACT_APP_GTM_ID`]